export default function (html) {
	const form = html.querySelector('form#frm-adHocMessageForm')
	if (form) {
		const hide = () => {
			Array.from(form.querySelectorAll('input[name="networks[]"]')).forEach((el) => {
				if (!el.checked) {
					const label = el.closest('label')
					label.classList.add('d-none');
					if (label.nextElementSibling) {
						label.nextElementSibling?.classList.add('d-none')
					}
				}
			})
		}

		const info = html.querySelector('[data-networks-typeahead]')
		const input = form.querySelector('input[name="networks[]"]')
		const typeahead = document.createElement('input')
		typeahead.classList.add('form-control')
		typeahead.classList.add('mb-2')

		if (info) {
			typeahead.setAttribute('placeholder', info.dataset.networksTypeahead)
		}

		typeahead.addEventListener('keyup', e => {
			hide()

			const value = e.currentTarget.value
			if (value.length > 2) {
				Array.from(form.querySelectorAll('input[name="networks[]"]')).forEach((el) => {
					if (el.closest('label').textContent.toLowerCase().startsWith(value.toString().toLowerCase())) {
						const label = el.closest('label')
						label.classList.remove('d-none');
						if (label.nextElementSibling) {
							label.nextElementSibling?.classList.remove('d-none')
						}
					}
				})
			} else {
				hide()
			}
		})

		hide()
		input.closest('.form-check').parentElement.prepend(typeahead)
	}
}
